var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 145,
    viewBox: "0 0 315 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79491 55.0349C3.79491 55.0349 0.294567 56.4052 0.000144958 59.2764V90.0112L3.89306 94.2527L10.8938 85.4107L3.79491 55.0349Z",
    fill: "#BAE0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51468 81.9196H309.503V107.336H4.51468V81.9196Z",
    fill: "#6E7178"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51468 103.258H309.503V107.304H4.51468V103.258Z",
    fill: "#525459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.185 89.4565H309.503V117.353H305.185V89.4565Z",
    fill: "#525459"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6433 20.2121H69.4243V82.1711L44.9219 82.2037C28.8596 82.4647 23.8217 94.0473 23.8217 94.0473H3.17945V53.7528L15.6433 20.2121Z",
    fill: "#E3E7EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.257 46.9107H10.174L18.4832 24.6263H46.257V46.9107Z",
    fill: "#BAE0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0725 21.5593H10.7301C13.0201 13.0763 22.049 11.4775 22.049 11.4775H70.0725V21.5593Z",
    fill: "#D1D4D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5475 128.444C24.3876 119.308 24.3876 104.496 33.5475 95.3606C42.7074 86.2249 57.5585 86.2249 66.7184 95.3606C75.8783 104.496 75.8783 119.308 66.7184 128.444C57.5585 137.58 42.7074 137.58 33.5475 128.444Z",
    fill: "#232426"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1172 96.6345C58.59 96.6345 65.4271 103.486 65.4271 111.904C65.4271 120.354 58.5573 127.174 50.1172 127.174C41.6444 127.174 34.8072 120.322 34.8072 111.904C34.8072 103.486 41.6771 96.6345 50.1172 96.6345ZM50.1172 124.172C56.8889 124.172 62.3847 118.69 62.3847 111.937C62.3847 105.183 56.8889 99.7015 50.1172 99.7015C43.3455 99.7015 37.8496 105.183 37.8496 111.937C37.8496 118.69 43.3455 124.172 50.1172 124.172Z",
    fill: "#525459"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1172 124.139C43.342 124.139 37.8497 118.661 37.8497 111.904C37.8497 105.147 43.342 99.6687 50.1172 99.6687C56.8924 99.6687 62.3848 105.147 62.3848 111.904C62.3848 118.661 56.8924 124.139 50.1172 124.139Z",
    fill: "#6E7178"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5013 115.524C44.4956 113.524 44.4956 110.281 46.5013 108.28C48.507 106.28 51.759 106.28 53.7647 108.28C55.7704 110.281 55.7704 113.524 53.7647 115.524C51.759 117.525 48.507 117.525 46.5013 115.524Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.887 128.458C183.728 119.323 183.728 104.511 192.887 95.3751C202.047 86.2394 216.898 86.2393 226.058 95.3751C235.218 104.511 235.218 119.323 226.058 128.458C216.898 137.594 202.047 137.594 192.887 128.458Z",
    fill: "#232426"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.465 96.6345C217.938 96.6345 224.775 103.486 224.775 111.904C224.775 120.354 217.905 127.174 209.465 127.174C200.992 127.174 194.155 120.322 194.155 111.904C194.122 103.486 200.992 96.6345 209.465 96.6345ZM209.465 124.172C216.237 124.172 221.732 118.69 221.732 111.937C221.732 105.183 216.237 99.7015 209.465 99.7015C202.693 99.7015 197.197 105.183 197.197 111.937C197.165 118.69 202.66 124.172 209.465 124.172Z",
    fill: "#525459"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.465 124.139C202.69 124.139 197.197 118.661 197.197 111.904C197.197 105.147 202.69 99.6687 209.465 99.6687C216.24 99.6687 221.732 105.147 221.732 111.904C221.732 118.661 216.24 124.139 209.465 124.139Z",
    fill: "#6E7178"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M205.841 115.539C203.836 113.538 203.836 110.295 205.841 108.295C207.847 106.294 211.099 106.294 213.105 108.295C215.11 110.295 215.11 113.538 213.105 115.539C211.099 117.539 207.847 117.539 205.841 115.539Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M254.358 128.452C245.199 119.316 245.199 104.504 254.358 95.3682C263.518 86.2325 278.369 86.2325 287.529 95.3682C296.689 104.504 296.689 119.316 287.529 128.452C278.369 137.587 263.518 137.587 254.358 128.452Z",
    fill: "#232426"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M270.934 96.6345C279.406 96.6345 286.244 103.486 286.244 111.904C286.244 120.354 279.374 127.174 270.934 127.174C262.494 127.174 255.624 120.322 255.624 111.904C255.591 103.486 262.461 96.6345 270.934 96.6345ZM270.934 124.172C277.705 124.172 283.201 118.69 283.201 111.937C283.201 105.183 277.705 99.7015 270.934 99.7015C264.162 99.7015 258.666 105.183 258.666 111.937C258.666 118.69 264.162 124.172 270.934 124.172Z",
    fill: "#525459"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.934 124.139C264.158 124.139 258.666 118.661 258.666 111.904C258.666 105.147 264.158 99.6687 270.934 99.6687C277.709 99.6687 283.201 105.147 283.201 111.904C283.201 118.661 277.709 124.139 270.934 124.139Z",
    fill: "#6E7178"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M267.312 115.532C265.306 113.532 265.306 110.288 267.312 108.288C269.318 106.287 272.57 106.287 274.576 108.288C276.581 110.288 276.581 113.532 274.576 115.532C272.57 117.532 269.318 117.532 267.312 115.532Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1172 83.8446C65.329 83.8446 77.7601 95.9493 78.2508 110.99H73.5074C73.0167 98.5268 62.7119 88.5103 50.1172 88.5103C37.4898 88.5103 27.2177 98.4942 26.727 110.99H21.9836C22.4743 95.9493 34.9054 83.8446 50.1172 83.8446Z",
    fill: "#525459"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M209.465 83.8446C224.677 83.8446 237.108 95.9493 237.599 110.99H232.855C232.364 98.5268 222.06 88.5103 209.465 88.5103C196.87 88.5103 186.565 98.4942 186.075 110.99H181.331C181.822 95.9493 194.22 83.8446 209.465 83.8446Z",
    fill: "#525459"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M270.934 83.8446C286.145 83.8446 298.577 95.9493 299.067 110.99H294.324C293.833 98.4942 283.561 88.5103 270.934 88.5103C258.306 88.5103 248.034 98.4942 247.544 110.99H242.8C243.291 95.9493 255.722 83.8446 270.934 83.8446Z",
    fill: "#525459"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.257 24.6263V46.9107L18.4832 24.6263H46.257Z",
    fill: "#91CAFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9241 64.2357C33.9241 63.1916 34.84 62.3759 35.985 62.3759H43.5745C44.7195 62.3759 45.6355 63.2242 45.6355 64.2357C45.6355 65.2797 44.7195 66.0954 43.5745 66.0954H35.985C34.84 66.0954 33.9241 65.2471 33.9241 64.2357Z",
    fill: "#D1D4D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.057 25.8988C55.057 25.2789 55.7439 24.7895 56.5945 24.7895H63.5952C64.4457 24.7895 65.1327 25.2789 65.1327 25.8988V45.4425C65.1327 46.0624 64.4457 46.5518 63.5952 46.5518H56.5945C55.7439 46.5518 55.057 46.0624 55.057 45.4425V25.8988Z",
    fill: "#BAE0FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M309.47 98.8531H314.606V113.079H309.47V98.8531Z",
    fill: "#525459"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 235.515,
    height: 82.3879,
    transform: "matrix(-1 0 0 1 309.333 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 235.515,
    height: 82.3879,
    transform: "matrix(-1 0 0 1 309.333 0)",
    fill: "#EAEDF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckVehicle);
export default __webpack_public_path__ + "static/media/truck-vehicle.5e619662.svg";
export { ForwardRef as ReactComponent };